// extracted by mini-css-extract-plugin
export default {"wrapper":"Layout_wrapper__m+abm"};